<template>
    <el-dialog
        custom-class="multi-select-modal-dialog"
        :title="title" :visible="visible" :modal="modal"
        :modal-append-to-body="false" :close-on-click-modal="false"
        @close="closeDialog" :show-close="false"
    >
        <div class="dialog-title" slot="title">
            <span class="f18 fw-400 c-333 m-r-10">{{ title }}</span>
            <el-alert
                v-if="modalHandTips"
                :title="modalHandTips"
                type="warning"
                show-icon
                :closable="false">
            </el-alert>
        </div>
        <div class="dialog-content">
            <DapMultiSelectPanel
                ref="multiSelectPanel"
                :resultList="selfResultList" v-bind="$attrs"
                :dataList="dataList"
                :loadMore="loadMore"
                :excludeSelected="exclude"
                :showExcludeSelected="showExcludeSelected"
                :maxLenth="maxLenth"
                @excludeSelectedChange="excludeSelectedChange"
                @change="handleChangeSelect"
            >
                <slot slot="search-prefix" name="search-prefix" />
                <slot slot="search-prepend" name="search-prepend" />
                <slot slot="select-all-tip" name="select-all-tip" />
                <slot slot="left-title" name="left-title" />
                <template v-slot:result="{item}">
                    <slot name="result" :item="item"></slot>
                </template>
                <template v-slot:label="{item}">
                    <slot name="label" :item="item"></slot>
                </template>
            </DapMultiSelectPanel>
            <div slot="footer" class="dialog-footer m-t-10">
                <el-button @click="closeDialog" size="mini">取 消</el-button>
                <el-button type="primary" @click="confirm" size="mini" :disabled="isDisabled">确 定</el-button>
            </div>
        </div>

    </el-dialog>
</template>

<script>
import DapMultiSelectPanel from './MultiSelectPanel';

export default {
    name: 'DapMultiSelectDialog',
    components: {
        DapMultiSelectPanel,
    },
    props: {
        resultList: {
            type: Array,
            default: () => []
        },
        title: {
            type: String,
            default: '多选',
        },
        visible: {
            type: Boolean,
            default: false,
        },
        modal: {
            type: Boolean,
            default: true,
        },
        dataList: {
            type: Array,
            default: () => []
        },
        loadMore: {
            type: Function,
            default: null,
        },
        excludeSelected: {
            type: Boolean,
            default: false,
        },
        showExcludeSelected: {
            type: Boolean,
            default: false,
        },
        modalHandTips: {
            type: String,
            default: '',
        },
        maxLenth: {
            type: Number,
            default: 0
        },
    },
    computed: {
        isDisabled () {
            let state = false;
            if(this.maxLenth) {
                state = this.selfResultList.length > this.maxLenth;
            }
            return state;
        },
    },
    data () {
        return {
            selfResultList: [],
            firstLoad: true,
            exclude: false
        };
    },
    methods: {
        excludeSelectedChange (val) {
            this.exclude = val;
        },

        handleChangeSelect (res) {
            this.selfResultList = res;
        },

        closeDialog () {
            this.$emit('update:visible', false);
        },

        confirm () {
            // 传出数据
            this.$emit('change', this.selfResultList, this.exclude);
            this.closeDialog();
        },
    },

    watch: {
        visible: {
            handler (val) {
                if (val) {
                    this.selfResultList = this.resultList;
                    this.exclude = this.excludeSelected;
                    this.$nextTick(() => {
                        if (this.$refs.multiSelectPanel && !this.firstLoad) {
                            this.$refs.multiSelectPanel.reset();
                        }
                        this.firstLoad = false;
                    });
                }
            },
            immediate: true,
        }
    }
};
</script>

<style lang="scss">
.multi-select-modal-dialog.el-dialog {
    width: 710px ;
    .el-dialog__header {
        text-align: left;
        .dialog-title {
            display: flex;
            align-items: center;
            .el-alert {
                width: auto;
                max-width: 460px;
                padding: 7px 16px;
                line-height: normal;
                i {
                    color: #E6A23C !important;
                }
            }
        }
    }

    .el-dialog__body {
        padding: 0;
        .dialog-content {
            padding: 0 20px 20px 20px;
        }
    }


    .dialog-footer {
        text-align: right;
    }
}
</style>
